/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const roleTypeApi = async (): Promise<any> => {
  const roleTypes = useJSONStore.getState().roleTypes;
  const token = useUserStore.getState().userToken;
  const setRoleType = useJSONStore.getState().setRoleType;

  if (roleTypes.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.roleType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setRoleType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default roleTypeApi;
